import { Link } from 'react-router-dom';

import type { ResearchSummary } from '@/api/types';
import { useSession } from '@/session/SessionContext';

/** The prompt version a run used; whoever may view the prompt opens it on Configuration → Business Opportunities. */
export function PromptVersionLabel({ run }: { run: ResearchSummary }) {
  const { can } = useSession();
  if (!run.prompt_version) return <>Not recorded</>;
  if (run.prompt_version_number === null || !can('research.prompt.view')) {
    return <span className="mono">{run.prompt_version}</span>;
  }
  return (
    <Link
      className="mono"
      to={`/configuration?tab=business-opportunities&part=prompt&version=${run.prompt_version_number}`}
      title="Open this prompt version"
    >
      {run.prompt_version}
    </Link>
  );
}
